<template>
    <div class="task-list">
        <template
            v-for="(item, i) in items"
        >
            <div
                :key="item.id"
                class="item"
                :class="{ 'loading': loading[item.id] }"
            >
                <ModelCheckbox
                    :input-value="item.completed"
                    @change="toggleCompleted(item)"
                    class="checkbox"
                />
                <div class="content" @click="$emit('click', i)">
                    <span class="name">{{ item.name }}</span>
                    <div class="deadline">{{ item.deadline.getTime() / 1000 | timestampFullDate(true) }}</div>
                </div>
                <div>
                    <div
                        class="delete"
                        @click="remove(item)"
                    >+</div>
                </div>
            </div>
            <div
                :key="i"
                class="hr"
            ></div>
        </template>
    </div>
</template>

<script>
import ModelCheckbox from '../../../../UI/models/ModelCheckbox';
import {mapActions} from 'vuex';

const actions = [
    'setCompletion',
    'removeTask',
];

export default {
    name: 'TaskList',
    components: {
        ModelCheckbox,
    },
    data: () => ({
        loading: {},
    }),
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    methods: {
        ...mapActions('mentoring/tasks', actions),
        async toggleCompleted(item) {
            this.$set(this.loading, item.id, true);
            await this.setCompletion({
                taskId: item.id,
                isCompleted: !item.completed,
            });
            this.$set(this.loading, item.id, false);
        },
        async remove(item) {
            this.$set(this.loading, item.id, true);
            await this.removeTask(item.id);
            this.$set(this.loading, item.id, false);
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../../../styles/rem';

    .item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: rem(56);


        @include on-mobile {
            align-items: flex-start;
            height: mrem(56);
        }

        &:hover {
            .delete {
                opacity: 1;
            }
        }
    }
    .content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-right: rem(16);
        margin-left: rem(12);
        align-items: center;
        height: rem(40);
        cursor: pointer;

        @include on-mobile {
            display: block;
            margin-right: mrem(16);
            margin-left: 0;
            align-items: center;
            height: mrem(40);
        }

        @include on-desktop {
            &:hover {
                > .name,
                > .deadline {
                    font-weight: 600;
                    color: #4663AB;
                }
            }
        }

    }
    .name {
        font-size: rem(16);
        line-height: rem(20);
        color: #2A2626;

        @include on-mobile {
            font-size: mrem(16);
            line-height: mrem(24);
        }
    }
    .deadline {
        font-weight: 600;
        font-size: rem(16);
        line-height: rem(20);
        text-align: right;
        color: #2A2626;

        @include on-mobile {
            font-weight: normal;
            text-align: left;
            font-size: mrem(16);
            line-height: mrem(24);
        }
    }
    .delete {
        width: rem(24);
        height: rem(24);
        font-size: rem(24);
        font-weight: 300;
        border-radius: 50%;
        background: #EF627D;
        color: white;
        transform: rotate(-45deg);
        line-height: rem(24);
        vertical-align: bottom;
        text-align: center;
        cursor: pointer;
        user-select: none;
        opacity: 0;
        transition: opacity .2s ease;

        @include on-mobile {
            width: mrem(24);
            height: mrem(24);
            font-size: mrem(24);
            line-height: mrem(24);
            opacity: 1;
        }
    }
    .checkbox {
        cursor: pointer;
        margin-bottom: 0;
        padding: rem(8) 0;

        @include on-mobile {
            padding: mrem(8) 0;
        }
    }
    .hr {
        height: 1px;
        border-bottom: 1px solid #E4E6E5;
        margin-left: rem(28);

        @include on-mobile {
            margin-left: 0;
        }
    }

    .loading {
        &,
        .checkbox,
        .content,
        .delete {
            cursor: wait!important;
        }

        .content:hover {
            > .name {
                font-weight: 500;
            }
            > * {
                color: black;
            }
        }
    }
</style>